export const BCBAResponseToRBTQuestionGraph = () => {
  return <div>Coming Soon....</div>;
};
